// import Vue from "vue"

// const forms = new Vue({
//   getTranslatedLabel(type) {
//     return this.$t(`label.${type}`)
//   },

//   getTranslatedPlaceholder(type) {
//     return this.$t(`placeHolder.${type}`)
//   },
// })

export default ({ i18n, $swal, app, context }, inject) => {
  const hello = (msg) => msg
  // Inject $hello(msg) in Vue, context and store.
  inject('hello', hello)
  // For Nuxt <= 2.12, also add 👇
  // context.$hello = hello

  const showModalDialog = (title, description, type) => {
    $swal({
      icon: type,
      html:
        '<div class="dialog-container">' +
        '<span class="icon type_icon_' +
        type +
        '"></span>' +
        '<div class="content_dialog_general">' +
        '<span class="titleModal">' +
        title +
        '</span>' +
        '<span class="descriptionModal">' +
        description +
        '</span>' +
        '</div>' +
        '</div>',
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      focusConfirm: false,
    })
  }

  inject('showModalDialog', showModalDialog)

  const showErrorModalDialog = (
    error,
    fallbackDescription = '',
    title = i18n.t(`errorOccurred`)
  ) => {
    const errorMsg =
      error?.response?.data?.errors?.join('<br />') ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      fallbackDescription ||
      'Ha ocurrido un error inesperado. Por favor intenta nuevamente.';

    showModalDialog(title, errorMsg, 'error');
  }

  inject('showErrorModalDialog', showErrorModalDialog)
}
